import { createContext, useContext } from "react";
import { MapCanvasInteractionState } from "./MapCanvasContext.types";

export const MapCanvasInteractionContext =
  createContext<MapCanvasInteractionState | null>(null);

export const useMapCanvasInteraction = () => {
  const context = useContext(MapCanvasInteractionContext);
  if (!context) {
    throw new Error(
      "useMapCanvasInteraction must be used within a MapCanvasProvider"
    );
  }
  return context;
};
